export const PROFILE_SHEET = {
  BORN_LABEL: 'Né{{(e)}} le {{date}}',
};
